import type { VoidFunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import type { DependencyV2Modals } from '../hooks/useDependencyModals';
import RevisionModalWrapper from '../../../modals/RevisionModalWrapper';
import type { OnSaveDependencyState } from '../../dependencies/ModalEditDependency';
import ModalEditDependency from '../../dependencies/ModalEditDependency';
import { window } from '../../../../globals';
import { verify_subscription } from '../../../../utils';
import * as DependenciesV2Store from '../../../../redux/dependenciesV2';

type Props = {
  modals: DependencyV2Modals;
  projectRevision?: string;
  onProjectChange: () => void;
};

const EditDependency: VoidFunctionComponent<Props> = ({ projectRevision, modals, onProjectChange }) => {
  const dispatch = useDispatch();
  const { isOpen, onClose } = modals.editDependencyModal;
  const { revision } = modals.editDependencyModal.context;

  if (!revision) {
    return null;
  }

  const onSaveDependency = async (revisionToCorrect: string, state: OnSaveDependencyState): Promise<void> => {
    if (!verify_subscription('premium')) {
      window.showPlanSelectorModal();
      return;
    }

    dispatch(DependenciesV2Store.actions.correctDependency(revisionToCorrect, state));
    onProjectChange();
  };

  return (
    <RevisionModalWrapper
      revision={revision}
      show={isOpen}
      onHide={onClose}>
      <ModalEditDependency
        parentRevisionLocator={projectRevision}
        onDependencySave={onSaveDependency}
        show={isOpen}
        onHide={onClose}
      />
    </RevisionModalWrapper>

  );
};

export default EditDependency;
